import { WhatsAppSenderFields } from 'modules/graphql';
import { createContext, useContext } from 'react';

export type DrawerState = string | null;

// for additional drawers that need metadata this type should be extended with a union
export type DrawerMetadata = WhatsAppSenderFields;

export type DrawerContextState = {
  isDrawerOpen: boolean;
  showDrawer: (metadata?: DrawerMetadata) => void;
  hideDrawer: () => void;
  drawerMetadata?: DrawerMetadata;
};

const defaultState = {
  isDrawerOpen: false,
  showDrawer: () => null,
  hideDrawer: () => null,
  drawerMetadata: undefined,
};

export const DrawerContext = createContext<DrawerContextState>(defaultState);

export const useDrawerContext = () => {
  const { showDrawer, hideDrawer, isDrawerOpen, drawerMetadata } = useContext(DrawerContext);

  return {
    isDrawerOpen,
    showDrawer,
    hideDrawer,
    drawerMetadata,
  };
};
